import { getAuthHeaders } from '../../../actions/authActions';
import tempMeeApi from '../../../apis/tempMee';

export const revokeACHAuthorization = async (bankId) => {
  const headers = await getAuthHeaders();
  const response = await tempMeeApi.post(
    `/payment/admin/account/payment-method/${bankId}/revoke`,
    {},
    { headers },
  );

  return response.data;
};
